var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPausecomponent = function SvgPausecomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h6v26H0zm14 0h6v26h-6z"
  })));
};
export default SvgPausecomponent;